export const state = () => ({
	emeraldDocs: {},
	rubyDocs: {},
	diamondDocs: {},
});

export const mutations = {
	setEmeraldDocs(state: any, payload: any) {
		state.emeraldDocs = payload;
	},

	setRubyDocs(state: any, payload: any) {
		state.rubyDocs = payload;
	},

	setDiamondDocs(state: any, payload: any) {
		state.diamondDocs = payload;
	},
};

export const getters = {
	getEmeraldDocs: (state: any) => state.emeraldDocs,
	getRubyDocs: (state: any) => state.rubyDocs,
	getDiamondDocs: (state: any) => state.diamondDocs,
};



export const actions = {
	async getUploadedDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/employability-awards/get-uploaded-logbooks')
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async uploadDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/employability-awards/', payload,{
					headers: {'Content-Type': 'multipart/form-data' }
				})
				.then((res) => {
					// console.log(res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/employability-awards/delete/' + payload.uuid)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getSubmittableStatus(state: any, payload: any){
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/employability-awards/submittable-status')
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async submitForAward(state: any, payload: any){
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/employability-awards/submit', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateEmeraldDocs(state: any, payload: any) {
		state.commit('setEmeraldDocs', payload);
	},

	updateRubyDocs(state: any, payload: any) {
		state.commit('setRubyDocs', payload);
	},

	updateDiamondDocs(state: any, payload: any) {
		state.commit('setDiamondDocs', payload);
	},

};
